module.exports = __webpack_public_path__ + "static/media/speiLogo.9234eb93.svg";